// Set to the Microsoft Bookings page URL; empty falls back to email.
export const BOOKINGS_URL = "https://bookings.cloud.microsoft/bookwithme/user/5cd99071636b462b95c8f1000ed3b73f@eragroup.com?anonymous&ep=signature&ismsaljsauthenabled";
export const CONTACT = {
  email: "office@extravalue.ro",
  phone: "+40 743 332 000",
  phoneHref: "tel:+40743332000",
  address: "Str. Basarab nr. 2, Sat Ciofliceni, Comuna Snagov, jud. Ilfov",
  founder: "Remus Hîrceagă",
};
export const bookingHref = () => BOOKINGS_URL || `mailto:${CONTACT.email}?subject=Discu%C8%9Bie%2030%20min%20-%20Extra%20Value`;

export const CONTENT = {
  ro: {
    nav: [
      { id: "proces", label: "Proces" },
      { id: "categorii", label: "Ce analizăm" },
      { id: "model", label: "Model" },
      { id: "calculator", label: "Calculator" },
      { id: "fondator", label: "Fondator" },
    ],
    cta: "Programează o discuție",
    hero: {
      eyebrow: "Energie electrică & gaze naturale · IMM România",
      lines: ["Reducem costurile", "cu energia și gazele", "companiei tale."],
      accent: "Ne plătești din economii.",
      sub: "Analizăm facturile și contractele de energie electrică și gaze naturale, le comparăm cu piața, renegociem în numele tău și monitorizăm rezultatul. Dacă nu găsim economii, nu plătești nimic.",
      primary: "Programează 30 de minute",
      secondary: "Estimează economia",
      chips: [
        { k: "0 RON", v: "avans" },
        { k: "0", v: "ore facturate" },
        { k: "30 ani", v: "în industria energetică" },
      ],
      card: { label: "Onorariu", value: "% din economie", note: "plătit după ce economia apare pe factură" },
      scroll: "Derulează",
    },
    marquee: ["Energie electrică", "Fără avans", "Gaze naturale", "Fără ore facturate", "30 de ani în energie", "Plătești doar din economii"],
    leaks: {
      eyebrow: "01 — Unde se pierd banii",
      title: "Factura de energie se plătește.",
      titleAccent: "Contractul din spatele ei rareori se recitește.",
      intro: "Energia electrică și gazele naturale se plătesc lunar, de obicei fără ca cineva să verifice dacă prețul și condițiile mai corespund pieței. Factura vine, se plătește, se arhivează.",
      items: [
        "Contractul de energie semnat în vara lui 2025, când piața tocmai ieșise de sub schema de sprijin și nimeni nu știa ce urmează.",
        "Clauza de reînnoire tacită care l-a dus mai departe fără să recalculeze nimeni.",
        "Puterea contractată stabilită acum câțiva ani, care nu mai corespunde consumului real.",
        "Formula de indexare a gazelor pe care nimeni din firmă nu o mai poate explica.",
      ],
      outro: "Fiecare detaliu, luat separat, pare prea mic ca să merite atenția directorului financiar. Adunate, sunt bani reali care pleacă în fiecare lună.",
      punch: "Noi ne uităm exact acolo.",
    },
    process: {
      eyebrow: "02 — Cum lucrăm",
      title: "Patru pași. Cifrele tale, pe masă.",
      steps: [
        { t: "Analiza situației", d: "Ne dai acces la facturile și contractele de energie electrică și gaze naturale. Le citim, le structurăm și îți arătăm cum se formează costul. Primești un Raport de Situație cu cifrele tale, indiferent dacă mergem mai departe împreună sau nu." },
        { t: "Benchmark de piață", d: "Comparăm prețul și condițiile tale cu ce se obține în piață pentru un profil de consum similar. Prețul corect depinde de volum, de profilul de consum, de durata contractului și de modul de indexare." },
        { t: "Renegociere sau relicitare", d: "Mergem la furnizorul tău actual de energie sau gaze cu argumente concrete. Dacă piața are ceva mai bun, organizăm o licitație structurată și îți punem ofertele furnizorilor pe aceeași masă, normalizate, ca să le poți compara real." },
        { t: "Implementare și monitorizare", d: "Decizia îți aparține. Ne ocupăm de schimbarea furnizorului sau de actul adițional și verificăm lunar că economiile promise apar efectiv pe factură." },
      ],
    },
    categories: {
      eyebrow: "03 — Ce analizăm",
      title: "Unde căutăm economia.",
      items: [
        { t: "Energie electrică", d: "Energia activă, cea mai importantă componentă a facturii, plus prețul componentei de furnizare, tipul de contract (preț fix sau indexat), puterea contractată, energia reactivă, profilul de consum și clauzele de reînnoire.", tag: "30 de ani în industria energetică" },
        { t: "Gaze naturale", d: "Prețul de furnizare, formula de indexare, capacitatea rezervată, profilul de consum sezonier și clauzele de reînnoire.", tag: "Gaze naturale" },
        { t: "Contracte și facturare", d: "Verificăm facturile linie cu linie, termenele, penalitățile și condițiile de ieșire, ca să nu plătești pentru erori sau clauze uitate.", tag: "Contracte" },
      ],
    },
    model: {
      eyebrow: "04 — Modelul comercial",
      nos: ["Nu facturăm ore.", "Nu cerem avans.", "Nu percepem abonament."],
      fee: "Onorariul nostru e un procent din economiile realizate, plătit după ce economia apare pe factura ta.",
      honest: "Dacă analiza arată că plătești deja corect, îți spunem asta și ne oprim acolo.",
      aligned: "Interesul nostru e aliniat cu al tău prin construcție.",
      alignedAccent: "Câștigăm doar dacă tu câștigi.",
    },
    calc: {
      eyebrow: "05 — Calculator",
      title: "Cât ar putea rămâne în companie?",
      sub: "Introdu cheltuiala lunară cu energia electrică și gazele naturale. Economia obținută este, în medie, de 5–10%.",
      monthly: "Cheltuială lunară",
      perMonth: "Economie estimată / lună",
      perYear: "Economie estimată / an",
      fee: "Avans plătit de tine",
      disclaimer: "Estimare orientativă bazată pe o economie medie de 5–10% la energie electrică și gaze naturale. Cifrele reale rezultă doar din Analiza situației pe facturile tale.",
      cats: { electricity: "Energie electrică", gas: "Gaze naturale" },
      cta: "Verifică cifrele reale",
    },
    founder: {
      eyebrow: "06 — Fondator",
      role: "Fondator, Extra Value",
      bio: "Peste 30 de ani petrecuți în industria energetică, în roluri de conducere la companii precum OMV Petrom, ExxonMobil și BP, și ca fondator și fost CEO al Țiriac Energy. Știe cum gândesc furnizorii, pentru că a stat de cealaltă parte a mesei.",
      career: ["Țiriac Energy — fondator & ex-CEO", "OMV Petrom", "ExxonMobil", "BP"],
      label: "Parcurs",
    },
    audience: {
      eyebrow: "07 — Cui ne adresăm",
      title: "Companii mici și mijlocii din România",
      body: "pentru care energia electrică și gazele naturale au devenit o linie importantă de cost, dar care nu au un specialist dedicat în achiziția de energie.",
      test: "Practic: dacă nimeni din firmă nu are ca sarcină să urmărească piața de energie și să renegocieze contractele, probabil avem ce discuta.",
      points: ["Factura de energie sau gaze contează în buget", "Nu există un specialist în achiziția de energie", "Contractele se reînnoiesc din inerție"],
    },
    contact: {
      title: "Vrei să știi dacă plătești prea mult pe energie?",
      body: "Prima discuție durează 30 de minute și nu costă nimic. Îți spunem direct dacă vedem potențial sau nu. Răspundem în cel mult o zi lucrătoare.",
      email: "Email", phone: "Telefon", address: "Adresă", founder: "Fondator",
    },
    footer: {
      legal: "Extra Value e marcă a EVENT AGE CONSULTING S.R.L.",
      ids: ["CUI 15315104", "J23/1581/08.04.2019", "EUID ROONRC.J23/1581/2019"],
      seat: "Sediu social: Sat Ciofliceni, Comuna Snagov, Str. Basarab nr. 2, jud. Ilfov",
      rights: "Toate drepturile rezervate.",
      top: "Înapoi sus",
    },
  },
  en: {
    nav: [
      { id: "proces", label: "Process" },
      { id: "categorii", label: "What we analyse" },
      { id: "model", label: "Model" },
      { id: "calculator", label: "Calculator" },
      { id: "fondator", label: "Founder" },
    ],
    cta: "Book a call",
    hero: {
      eyebrow: "Electricity & natural gas · Romanian SMEs",
      lines: ["We cut your", "company's electricity", "and gas costs."],
      accent: "You pay us from the savings.",
      sub: "We analyse your electricity and natural gas invoices and contracts, benchmark them against the market, renegotiate on your behalf and monitor the result. If we find no savings, you pay nothing.",
      primary: "Book 30 minutes",
      secondary: "Estimate savings",
      chips: [
        { k: "0 RON", v: "upfront" },
        { k: "0", v: "billable hours" },
        { k: "30 yrs", v: "in the energy industry" },
      ],
      card: { label: "Our fee", value: "% of savings", note: "paid once the saving shows on your invoice" },
      scroll: "Scroll",
    },
    marquee: ["Electricity", "No upfront fee", "Natural gas", "No billable hours", "30 years in energy", "Paid only from savings"],
    leaks: {
      eyebrow: "01 — Where the money leaks",
      title: "The energy bill gets paid.",
      titleAccent: "The contract behind it rarely gets reread.",
      intro: "Electricity and natural gas are paid every month, usually without anyone checking whether the price and terms still match the market. The invoice arrives, gets paid, gets filed.",
      items: [
        "The energy contract signed in summer 2025, just as the market came off the support scheme and nobody knew what was next.",
        "The tacit renewal clause that rolled it forward without anyone recalculating.",
        "The contracted capacity set years ago that no longer matches actual consumption.",
        "The gas indexation formula nobody in the company can explain anymore.",
      ],
      outro: "Each detail, on its own, seems too small for the CFO's attention. Added up, it's real money leaving every month.",
      punch: "That's exactly where we look.",
    },
    process: {
      eyebrow: "02 — How we work",
      title: "Four steps. Your numbers, on the table.",
      steps: [
        { t: "Situation analysis", d: "You give us access to your electricity and natural gas invoices and contracts. We read them, structure them and show you how the cost is built. You receive a Situation Report with your figures, whether or not we continue together." },
        { t: "Market benchmark", d: "We compare your price and terms with what the market offers for a similar consumption profile. The right price depends on volume, consumption profile, contract length and indexation method." },
        { t: "Renegotiation or re-tender", d: "We go to your current electricity or gas supplier with concrete arguments. If the market has something better, we run a structured tender and put the supplier offers side by side, normalised, so you can truly compare them." },
        { t: "Implementation & monitoring", d: "The decision is yours. We handle the supplier switch or contract amendment and check every month that the promised savings actually appear on the invoice." },
      ],
    },
    categories: {
      eyebrow: "03 — What we analyse",
      title: "Where we look for savings.",
      items: [
        { t: "Electricity", d: "Active energy, the most important component of the bill, plus the supply price component, contract type (fixed or indexed), contracted capacity, reactive energy, consumption profile and renewal clauses.", tag: "30 years in the energy industry" },
        { t: "Natural gas", d: "Supply price, indexation formula, booked capacity, seasonal consumption profile and renewal clauses.", tag: "Natural gas" },
        { t: "Contracts & billing", d: "We check invoices line by line, plus terms, penalties and exit conditions, so you don't pay for errors or forgotten clauses.", tag: "Contracts" },
      ],
    },
    model: {
      eyebrow: "04 — Commercial model",
      nos: ["We don't bill hours.", "We don't ask for advances.", "We don't charge retainers."],
      fee: "Our fee is a percentage of the savings achieved, paid after the saving appears on your invoice.",
      honest: "If the analysis shows you already pay a fair price, we tell you so and stop there.",
      aligned: "Our interest is aligned with yours by design.",
      alignedAccent: "We only win if you win.",
    },
    calc: {
      eyebrow: "05 — Calculator",
      title: "How much could stay in the company?",
      sub: "Enter your monthly electricity and natural gas spend. Savings achieved average 5–10%.",
      monthly: "Monthly spend",
      perMonth: "Estimated saving / month",
      perYear: "Estimated saving / year",
      fee: "Upfront paid by you",
      disclaimer: "Indicative estimate based on an average saving of 5–10% on electricity and natural gas. Real figures come only from the Situation Analysis of your invoices.",
      cats: { electricity: "Electricity", gas: "Natural gas" },
      cta: "Check the real numbers",
    },
    founder: {
      eyebrow: "06 — Founder",
      role: "Founder, Extra Value",
      bio: "Over 30 years in the energy industry, in leadership roles at companies such as OMV Petrom, ExxonMobil and BP, and as founder and former CEO of Țiriac Energy. He knows how suppliers think, because he has sat on the other side of the table.",
      career: ["Țiriac Energy — founder & ex-CEO", "OMV Petrom", "ExxonMobil", "BP"],
      label: "Career",
    },
    audience: {
      eyebrow: "07 — Who we work with",
      title: "Small and mid-sized Romanian companies",
      body: "for which electricity and natural gas have become a significant cost line, but without a dedicated energy purchasing specialist.",
      test: "In practice: if nobody in the company is tasked with following the energy market and renegotiating contracts, we probably have something to talk about.",
      points: ["The electricity or gas bill matters in the budget", "No energy purchasing specialist", "Contracts renew by inertia"],
    },
    contact: {
      title: "Want to know if you're overpaying for energy?",
      body: "The first conversation takes 30 minutes and costs nothing. We'll tell you straight whether we see potential. We reply within one business day.",
      email: "Email", phone: "Phone", address: "Address", founder: "Founder",
    },
    footer: {
      legal: "Extra Value is a brand of EVENT AGE CONSULTING S.R.L.",
      ids: ["VAT ID 15315104", "J23/1581/08.04.2019", "EUID ROONRC.J23/1581/2019"],
      seat: "Registered office: Sat Ciofliceni, Comuna Snagov, Str. Basarab nr. 2, Ilfov County",
      rights: "All rights reserved.",
      top: "Back to top",
    },
  },
};
